import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstance";

interface RequestQuery {
    category: string;
    list_no: string;
}

interface RequestBody {
    status: string;
}

export type UpdateRequest = RequestQuery & RequestBody;

export interface UpdateResponse {
    statusCode: number;
    message: string;
    data: {
        list_no: number;
    };
}

export const usePutConsoleSuppliesStatus = (
    successCallback?: (data: UpdateResponse) => void,
): UseMutationResult<UpdateResponse, Error, UpdateRequest, unknown> => {
    const queryClient = useQueryClient();

    return useMutation<UpdateResponse, Error, UpdateRequest>({
        mutationFn: async (updateData: UpdateRequest) => {
            const url = enum_api_uri.put_console_supplies_status
                .replace(":category", updateData.category)
                .replace(":list_no", updateData.list_no);

            const response = await axiosInstance.put(url, {
                status: updateData.status,
            });
            return response.data.data;
        },
        onSuccess: data => {
            queryClient.invalidateQueries({ queryKey: ["useGetConsoleSupplies"] });
            successCallback?.(data);
        },
    });
};
